import React, { useState, useEffect } from 'react';


function Theme() {
    const [theme, setTheme] = useState(() => {
        // Leer el tema desde localStorage (por defecto: 'light')
        return localStorage.getItem('theme') || 'light';
    });

    // Aplicar el tema al body y guardarlo en localStorage
    useEffect(() => {
        document.body.className = theme;
        localStorage.setItem('theme', theme);
    }, [theme]);

    const toggleTheme = () => {
        setTheme(prev => (prev === 'light' ? 'dark' : 'light'));
    };

    return (
        <>


            {/* <button >Cambiar tema: Tema actual: {theme.toUpperCase()} |{' '}</button> */}
            <button onClick={toggleTheme} className="p-2 bg-secondary bg-opacity-10 rounded-3 text-secondary">
                {theme === "light"
                    ? <><i class="uil uil-moon"></i> <span>Tema: Oscuro</span></>

                    : <><i class="uil uil-sun"></i> <span>Tema: Claro</span></>}
            </button>
        </>
    );
}

export default Theme;